import { render, staticRenderFns } from "./psp-form.vue?vue&type=template&id=ec258288&scoped=true&"
import script from "./psp-form.vue?vue&type=script&lang=js&"
export * from "./psp-form.vue?vue&type=script&lang=js&"
import style0 from "./psp-form.vue?vue&type=style&index=0&id=ec258288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec258288",
  null
  
)

export default component.exports